import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=589b6785&scoped=true&lang=pug"
import script from "./PageLoading.vue?vue&type=script&lang=ts"
export * from "./PageLoading.vue?vue&type=script&lang=ts"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=589b6785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b6785",
  null
  
)

export default component.exports